module.exports = __webpack_public_path__ + "static/aup-0b43d7018a43a8db6737f787e59d32cc.jpg";